"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable: variable-name max-file-line-count */
var IAPWS95 = require("./iapws-95");
var VirialEquationOfState = require("./virial-equation-of-state");
var IAPWSIF97 = require("./iapws-if97");
var Lemmon = require("./lemmon");
var numerics_1 = require("../numerics");
var humidity_conversions_1 = require("./humidity-conversions");
var Guess = require("./guess");
var _1 = require(".");
/// <param name="T">Temperature [K] </param>
/// <param name="psi_w">[1/1]</param>
/// <param name="v_bar">Molar Volume of Moist Air [m3/mol]</param>
/// <returns>[J/mol]</returns>
function Get_Molar_Enthalpy_of_Moist_Air(T, psi_w, v_bar) {
    var hbaro_a = Lemmon.Get_Ideal_Gas_Molar_Enthalpy_of_Dry_Air(T);
    var hbaro_w;
    if (T >= 273.15) {
        // At temperatures T ≥ 273.15K use [1] eq. (3.47) and table 2.9
        hbaro_w = IAPWSIF97.Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_97(T);
    }
    else {
        // At temperatures T ≤ 273.15K use [1] eq. (3.48) and table 2.6
        hbaro_w = IAPWS95.Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_95(T);
    }
    // Not clear why getting rid of this term yields the correct values in the table, but enthalpies are equal to an additive constant, so not a big deal
    var hbar_0 = 0; // 2.924425468; // [kJ/kmol]
    var dB_m_dT = VirialEquationOfState.Get_dBm_dT(T, psi_w);
    var dC_m_dT = VirialEquationOfState.Get_dCm_dT(T, psi_w);
    var B_m = VirialEquationOfState.Get_Bm(T, psi_w);
    var C_m = VirialEquationOfState.Get_Cm(T, psi_w);
    var R_bar = 8.314472; // [kJ/(kmol K)]
    // tslint:disable-next-line:max-line-length
    var hbar = hbar_0 +
        (1 - psi_w) * hbaro_a +
        psi_w * hbaro_w +
        R_bar *
            T *
            ((B_m - T * dB_m_dT) * (1.0 / v_bar) +
                (C_m - (T / 2.0) * dC_m_dT) * (1 / Math.pow(v_bar, 2)));
    return hbar; //[kJ/kmol]
}
exports.Get_Molar_Enthalpy_of_Moist_Air = Get_Molar_Enthalpy_of_Moist_Air;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K] </param>
/// <param name="psi_w">[1/1]</param>
/// <returns>[m3/mol]</returns>
function Get_Molar_Volume_of_Moist_Air(p, T, psi_w) {
    if (p <= 0) {
        throw new Error("p");
    }
    // Get outside the loop since not a function of v_bar
    var Bm = VirialEquationOfState.Get_Bm(T, psi_w); // [cm3/mol]
    var Cm = VirialEquationOfState.Get_Cm(T, psi_w); // [cm6/mol2*K]
    // Start by assuming it is an ideal gas to get initial guess
    var R_bar = 8.314472; // [kJ/(kmol K)] = [J/(mol K)]
    var v_bar0 = (R_bar * T) / p;
    // Root-function, returns zero for correct guess
    var rootFunction = function (v_bar) {
        return p - ((R_bar * T) / v_bar) * (1 + Bm / v_bar + Cm / (v_bar * v_bar));
    };
    // Iteratively find molar volume
    //double[] minMax = Bracket.BracketOut(function, v_bar0 - 1, v_bar0, v_bar0 + 1, 100);
    //double v_bar_solved = BrentsMethod.BrentsMethodSolve(function, minMax[0], minMax[1], 1e-8);
    var v_bar_solved = numerics_1.SecantMethod.solve(rootFunction, v_bar0, 1e-8, 0.000001);
    return v_bar_solved;
}
exports.Get_Molar_Volume_of_Moist_Air = Get_Molar_Volume_of_Moist_Air;
/// <param name="p">Pressure [Pa]</param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <param name="h">Specific Enthalpy [kJ/kg]</param>
/// <returns>Temperature [°C]</returns>
function To_Temperature_From_HumidityRatio_And_SpecificEnthalpy(p, W, h) {
    // Initial guess
    var t_guess = 25;
    // Root-function, returns zero for correct guess
    var rootFunction = function (t) {
        return humidity_conversions_1.From_HumidityRatio_To_SpecificEnthalpy(p, t, W) - h;
    };
    // Iteratively find T
    var t_found = numerics_1.SecantMethod.solve(rootFunction, t_guess, 1e-8, 0.001);
    return t_found;
}
exports.To_Temperature_From_HumidityRatio_And_SpecificEnthalpy = To_Temperature_From_HumidityRatio_And_SpecificEnthalpy;
/// <param name="p">Pressure [Pa]</param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <param name="rh">Relative Humidity [%, where 0.5 = 50%]</param>
/// <returns>Temperature [°C]</returns>
function To_Temperature_From_HumidityRatio_And_RelativeHumidity(p, W, rh) {
    //if (p <= 0) throw new ArgumentOutOfRangeException("p");
    //if (W <= 0.00) throw new ArgumentOutOfRangeException("W");
    // Initial guess
    var t_guess = 20;
    // Root-function, returns zero for correct guess
    var rootFunction = function (t) {
        return humidity_conversions_1.From_HumidityRatio_To_RelativeHumidity(p, t, W) - rh;
    };
    // Iteratively find T
    //double t_found = SecantMethod.SecantMethodSolve(function, t_guess, 1e-8, 0.001);
    var minMax = numerics_1.Bracket.bracketOut(rootFunction, -273.14, t_guess, 2000, 100);
    var t_found = numerics_1.BrentsMethod.solve(rootFunction, minMax[0], minMax[1], 1e-8);
    if (t_found.Result === null) {
        throw new Error(t_found.ErrorText);
    }
    return t_found.Result;
}
exports.To_Temperature_From_HumidityRatio_And_RelativeHumidity = To_Temperature_From_HumidityRatio_And_RelativeHumidity;
/// <param name="p">Pressure [Pa]</param>
/// <param name="rh">Relative Humidity [%, where 0.5 = 50%]</param>
/// <param name="h">Specific Enthalpy [kJ/kg]</param>
/// <returns>Temperature [°C]</returns>
function To_Temperature_From_RelativeHumidity_And_SpecificEnthalpy(p, rh, h) {
    // Initial guess
    var t_guess = 25;
    // Root-function, returns zero for correct guess
    var rootFunction = function (t) {
        return humidity_conversions_1.From_RelativeHumidity_To_SpecificEnthalpy(p, t, rh) - h;
    };
    // Iteratively find T
    var t_found = numerics_1.SecantMethod.solve(rootFunction, t_guess, 1e-8, 0.001);
    return t_found;
}
exports.To_Temperature_From_RelativeHumidity_And_SpecificEnthalpy = To_Temperature_From_RelativeHumidity_And_SpecificEnthalpy;
/// <param name="p">Pressure [Pa]</param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <param name="t_wb">Wet-bulb [°C_wb]</param>
/// <returns>Temperature [°C]</returns>
function To_Temperature_From_HumidityRatio_And_WetBulb(p, W, t_wb) {
    // Initial guess
    var t_guess = Guess.ASHRAE2009_GetGuessForDryBulb_GivenWetBulbAndHumidityRatio(p, W, t_wb);
    // Root-function, returns zero for correct guess
    var rootFunction = function (t) {
        return humidity_conversions_1.From_HumidityRatio_To_WetBulb(p, t, W) - t_wb;
    };
    // Iteratively find T
    //double t_found = SecantMethod.Solve(rootFunction, t_guess, 1e-8, 0.001);
    var minMax = numerics_1.Bracket.bracketOut(rootFunction, -273.15, t_guess, 2000, 100);
    var t_found = numerics_1.BrentsMethod.solve(rootFunction, minMax[0], minMax[1], 1e-8);
    if (t_found.Result === null) {
        throw new Error(t_found.ErrorText);
    }
    return t_found.Result;
}
exports.To_Temperature_From_HumidityRatio_And_WetBulb = To_Temperature_From_HumidityRatio_And_WetBulb;
function Find_Saturation_Line_Enthalpy_Line_Intersection(p, h) {
    var tGuess = IAPWSIF97.Get_Saturation_Temperature_of_Water(p);
    var saturationSafety = 0.999995;
    var rootFunction = function (t) {
        var tdp = saturationSafety * (273.15 + t) - 273.15;
        var w = _1.HumidityConversions.To_HumidityRatio_From_DewPoint(p, tdp);
        return (_1.HumidityConversions.From_HumidityRatio_To_SpecificEnthalpy(p, t, w) - h);
    };
    var t_found = numerics_1.SecantMethod.solve(rootFunction, tGuess - 273.15, 1e-8, -0.01);
    var w_found = _1.HumidityConversions.To_HumidityRatio_From_DewPoint(p, saturationSafety * (t_found + 273.15) - 273.15);
    return { t: t_found, x: w_found };
}
exports.Find_Saturation_Line_Enthalpy_Line_Intersection = Find_Saturation_Line_Enthalpy_Line_Intersection;
